const name = 'BaseDimensions';
const properties = {};
function animate(kit, elements, duration = 0, delay = 0, params = {}) {
    return kit.engine.tween(elements, Object.assign({ duration, delay }, params), [
        'width',
        'height',
        'top',
        'left',
        'maxWidth',
        'maxHeight',
        'minWidth',
        'minHeight',
        'bottom',
        'right',
        'margin',
        'padding',
        'marginTop',
        'marginBottom',
        'marginLeft',
        'marginRight',
        'paddingTop',
        'paddingBottom',
        'paddingRight',
        'paddingLeft',
        'zIndex',
    ]);
}
export { name, properties, animate };
//# sourceMappingURL=baseDimensions.js.map